import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height="22" width="22" {...props}><path d="M50 1.1a48.9 48.9 0 10.02 97.82A48.9 48.9 0 0050 1.1zm29.7 32.5L41.8 80.4c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1L19.6 59c-.1-.1-.1-.4 0-.5l8.2-9.1c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1l12.2 12.1L70 25.1c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1l9.1 8.1c.1 0 .2.3 0 .4z" /></svg>);